import { Logo } from "./Nav";
import { EMAIL, NAV_LINKS, PHONE, PHONE_HREF, scrollToId } from "@/lib/site";

export default function Footer() {
  return (
    <footer className="bg-navy pb-8 pt-16 text-white">
      <div className="mx-auto grid max-w-[1200px] gap-12 px-5 md:grid-cols-3 md:px-8">
        <div>
          <Logo dark />
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-white/60">
            SundaySea Solutions LLC. Central Florida's trusted painting experts for over two
            decades. Premium residential &amp; commercial finishes, prepped and protected for the
            Florida climate.
          </p>
          <p className="mt-6 text-[11px] uppercase tracking-[0.24em] text-white/40">
            Licensed &amp; Insured · FL Contractor
          </p>
        </div>

        <div>
          <p className="text-[11px] uppercase tracking-[0.24em] text-[#e8a33d]">Navigate</p>
          <ul className="mt-5 space-y-3">
            {NAV_LINKS.map(([label, hash]) => (
              <li key={hash}>
                <button
                  data-testid={`footer-link-${hash.slice(1)}`}
                  onClick={() => scrollToId(hash)}
                  className="text-[15px] text-white/70 transition-colors hover:text-[#e8a33d]"
                >
                  {label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-[11px] uppercase tracking-[0.24em] text-[#e8a33d]">Get in touch</p>
          <ul className="mt-5 space-y-4 text-[15px]">
            <li>
              <a data-testid="footer-phone" href={PHONE_HREF} className="flex items-center gap-3 text-white/70 transition-colors hover:text-[#e8a33d]">
                <svg viewBox="0 0 24 24" className="h-4 w-4 text-[#e8a33d]" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                  <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3 19.5 19.5 0 0 1-6-6 19.8 19.8 0 0 1-3-8.7A2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 2 .7 2.8a2 2 0 0 1-.4 2.1L8.1 9.9a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.9.6 2.8.7a2 2 0 0 1 1.7 2z" />
                </svg>
                {PHONE}
              </a>
            </li>
            <li>
              <a data-testid="footer-email" href={`mailto:${EMAIL}`} className="flex items-center gap-3 break-all text-white/70 transition-colors hover:text-[#e8a33d]">
                <svg viewBox="0 0 24 24" className="h-4 w-4 shrink-0 text-[#e8a33d]" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                  <rect x="2" y="4" width="20" height="16" rx="2" />
                  <path d="m22 7-10 6L2 7" />
                </svg>
                {EMAIL}
              </a>
            </li>
            <li className="flex items-start gap-3 text-white/70">
              <svg viewBox="0 0 24 24" className="mt-1 h-4 w-4 shrink-0 text-[#e8a33d]" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z" />
                <circle cx="12" cy="10" r="3" />
              </svg>
              Serving Orlando, Lakeland, Tampa &amp; all of Central Florida
            </li>
          </ul>
        </div>
      </div>

      <div className="mx-auto mt-14 flex max-w-[1200px] flex-col gap-3 border-t border-white/10 px-5 pt-6 text-xs text-white/40 sm:flex-row sm:items-center sm:justify-between md:px-8">
        <p>© {new Date().getFullYear()} SundaySea Solutions LLC. All rights reserved.</p>
        <p>Privacy Policy · Terms of Service</p>
      </div>
    </footer>
  );
}
